import { Pipe, PipeTransform } from '@angular/core';
import { DataValidation } from '../interfaces';

@Pipe({
    name: 'targetSlotValidations'
})
export class TargetSlotValidationsPipe implements PipeTransform {
    transform(validations: DataValidation[] | undefined, slotId: string): DataValidation[] | undefined {
        return validations?.filter(v => v.targetTemplateSlot === slotId);
    }
}
